import API from "../utils/api";

export const ACTION_TYPES = {
    REVIEW_CREATE: 'REVIEW_CREATE',
    REVIEW_UPDATE: 'REVIEW_UPDATE',
    REVIEW_DELETE: 'REVIEW_DELETE',
    REVIEW_FETCH: 'REVIEW_FETCH',
    REVIEW_FETCH_ALL: 'REVIEW_FETCH_ALL',
    REVIEW_PAGINATION: 'REVIEW_PAGINATION'
}

export const fetchAll = () => dispatch => {
    API.review().fetchAll()
        .then(res => {
      
            dispatch({
                type: ACTION_TYPES.REVIEW_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, title = "") => dispatch => {
    API.review().fetchPagination(page, Math.abs(limit), title)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.REVIEW_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.review().fetchById(id)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.REVIEW_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.review().create(input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.REVIEW_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {
   
    API.review().update(id, input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.REVIEW_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.review().delete(id)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.REVIEW_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}